import axios from 'axios';
const api = process.env.REACT_APP_SERVER_API;

export default () => {
    axios.defaults.baseURL = api + 'comments';
    return axios;
};
